import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pre-incubation-home',
  templateUrl: './pre-incubation-home.component.html',
  styleUrls: ['./pre-incubation-home.component.css'],
})
export class PreIncubationHomeComponent implements OnInit {
  constructor(private router: Router) { }

  ngOnInit(): void {
    this.checkRegistrationStatus();
  }
  /**
   * Navigates to the pre-incubation registration page.
   */
  preincubtorregister() {
    this.router.navigateByUrl('/pre-incubator-register');
  }
  pdfUrl1 = 'assets/pdf/Pre Incubation Centre Doc.pdf';
  viewingPdf1 = false;
  /**
   * Downloads the Pre Incubation Centre Scheme Document PDF file.
   *
   * This function opens the PDF file in a new browser tab.
   */
  pdfDownload() {
    window.open(
      'https://startuptn-public-files.s3.ap-south-1.amazonaws.com/PreIncubationCentre_SchemeDocument.pdf',
      '_blank'
    );
  }

  pdfDownloadPIC() {
    window.open(
      'https://startuptn-public-files.s3.ap-south-1.amazonaws.com/List_of_Pre_Incubation_Centres.pdf',
      '_blank'
    );
  }
  isRegistrationClosedPre: boolean = false;
  /**
   * Checks if the registration is closed.
   *
   * This function compares the current date and time with a fixed deadline.
   * If the current date and time is after the deadline, it sets the
   * isRegistrationClosedPre flag to true, indicating that registration is closed.
   */
  checkRegistrationStatus(): void {
    // Define the deadline as November 23, 2025, 5:01 PM
    const deadline = new Date(2026, 2, 31, 23, 59, 0);

    // Get the current date and time
    const now = new Date();

    // Check if the current date and time is after the deadline
    this.isRegistrationClosedPre = now >= deadline;
  }
}
